import { useCallback, useMemo, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { VoucherType } from 'store/api-slice/types'
import { useIntl } from 'react-intl'

export const useSingleVoucher = ({
    voucherType,
}: {
    voucherType: VoucherType
}) => {
    const { formatMessage } = useIntl()
    const [isEditable, setIsEditable] = useState(false)

    const getButtonText = useCallback(() => {
        if (voucherType === 'amount') {
            return isEditable ? (
                <FormattedMessage
                    id="vouchers.config.save_data"
                    defaultMessage="Zapisz dane"
                />
            ) : (
                <FormattedMessage
                    id="vouchers.config.edit_data"
                    defaultMessage="Edytuj dane"
                />
            )
        }
        if (voucherType === 'product') {
            return isEditable ? (
                <FormattedMessage
                    id="vouchers.config.save_voucher"
                    defaultMessage="Zapisz zmiany"
                />
            ) : (
                <FormattedMessage
                    id="vouchers.config.edit_voucher"
                    defaultMessage="Edytuj voucher"
                />
            )
        }
    }, [isEditable])

    const vouchersDetails = useMemo(
        () => ({
            amount: formatMessage({
                id: 'vouchers.name.amount',
                defaultMessage: 'Kwotowy',
            }),
            product: formatMessage({
                id: 'vouchers.name.product',
                defaultMessage: 'Na kartę Unlimited',
            }),
        }),
        []
    )

    return { setIsEditable, getButtonText, vouchersDetails }
}
